import Vue from 'vue';
import Vuex from 'vuex';
import global from './modules/global';
import modals from './modules/modals';
import departments from './endpoints/departments';
import privileges from './endpoints/privileges';
import agents from './endpoints/agents';
import admins from './endpoints/admins';
import channels from './endpoints/channels';
import calls from './endpoints/calls';
import users from './endpoints/users';
import widget from './endpoints/widget';
import accounts from './endpoints/account';
import langs from './endpoints/languages';
import types from './endpoints/types';
import integrations from './endpoints/integrations';
import contracts from './endpoints/contracts';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global,
    modals,
    departments,
    privileges,
    agents,
    admins,
    channels,
    calls,
    users,
    widget,
    accounts,
    langs,
    types,
    integrations,
    contracts,
  },
});
